import { render, staticRenderFns } from "./AddSocmed.vue?vue&type=template&id=313bdc84&scoped=true&"
import script from "./AddSocmed.vue?vue&type=script&lang=js&"
export * from "./AddSocmed.vue?vue&type=script&lang=js&"
import style0 from "./AddSocmed.vue?vue&type=style&index=0&id=313bdc84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313bdc84",
  null
  
)

export default component.exports